import {
  Box,
  FormControlLabel,
  Grid,
  Skeleton,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

function CreditSection(props) {
  const setQuotaPerTeacher = (e) => {
    const credit = e.target.value;
    props.setCreditPerTeacher(parseInt(credit) || "");
  };

  const approvePerTeacherCredit = () => {
    if (props.creditPerTeacher) {
      const updatedTeachers = props.teachers.map((teacher) => ({
        ...teacher,

        credit: props.creditPerTeacher,
        status: "assign",
      }));

      props.setTeachers(updatedTeachers);
    }
  };

  const increaseCredits = () => {
    window.open("https://www.acv.app/credits", "_blank");
  };


  return (
    <>
      {/* {props.isMobileView ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "5px",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <TextField
            id="search-bar"
            className="text"
            variant="outlined"
            placeholder="Search..."
            size="small"
            value={props.searchTeacher}
            onChange={(e) => props.handleChange(e)}
            sx={{ width: "100%" }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <TextField
            id="search-bar"
            className="search-bar"
            variant="outlined"
            placeholder="Search..."
            size="small"
            value={props.searchTeacher}
            onChange={(e) => props.handleChange(e)}
          />
        </Box>
      )} */}

      {props.isMobileView ? (
        <Grid container>
          {/* <Grid xs={12}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", gap: "3px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Karla, sans-serif",
                    fontSize: "14px",
                  }}
                >
                  ACV Licences :
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Karla, sans-serif",
                    fontWeight: 600,
                  }}
                >
                  1000
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: "3px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Karla, sans-serif",
                    fontSize: "14px",
                  }}
                >
                  School Credits :
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Karla, sans-serif",
                    fontWeight: 600,
                  }}
                >
                  $300
                </Typography>
              </Box>
            </Box>
          </Grid> */}
          <Grid xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
            >
              <Box sx={{ display: "flex", gap: "3px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Karla, sans-serif",
                    fontSize: "14px",
                  }}
                >
                  Available Credits :
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Karla, sans-serif",
                    fontWeight: 600,
                  }}
                >
                  {props?.creditInfo?.credit > -1 ? (
                    "$ " + props.creditInfo.credit
                  ) : (
                    <Skeleton
                      width={30}
                      variant="text"
                      sx={{ fontSize: "1rem" }}
                    />
                  )}
                </Typography>
              </Box>
              {/* <Button
                sx={{
                  color: "rgb(0, 0, 0)",
                  border: "1px solid rgb(225, 223, 221)",
                  fontFamily: "Karla, sans-serif",
                  boxShadow: "rgba(0, 0, 0, 0.25) 0px 0.2rem 0.4rem -0.075rem",
                  fontWeight: 600,
                  width: "147px",
                  height: "30px",
                  fontSize: "12px",
                }}
                onClick={increaseCredits}
              >
                $ Increase Credits
              </Button> */}
              <a
                href={`https://www.acv.app/credits`}
                target="_blank"
                style={{
                  color: "rgb(0, 0, 0)",
                  border: "1px solid rgb(225, 223, 221)",
                  fontFamily: "Karla, sans-serif",
                  boxShadow: "rgba(0, 0, 0, 0.25) 0px 0.2rem 0.4rem -0.075rem",
                  fontWeight: 600,
                  width: "147px",
                  height: "30px",
                  fontSize: "12px",
                  borderRadius: "5px",
                  textTransform: "uppercase",
                  padding: "5px",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                $ Increase Credits
              </a>
            </Box>
          </Grid>
          {/* <Grid xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontFamily: "Karla, sans-serif",
                  fontSize: "14px",
                }}
              >
                Credits per teacher:
              </Typography>
              <TextField
                className="outlined-basic-mobile"
                label="Quota per teacher"
                variant="outlined"
                size="small"
                sx={{ width: "147px" }}
                value={props.creditPerTeacher}
                onChange={setQuotaPerTeacher}
              />
              {props.creditPerTeacher && (
                <LoadingButton
                  className="assigned"
                  loadingPosition="start"
                  variant="contained"
                  style={{
                    backgroundColor: "rgb(98, 100, 167)",
                    height: "28px",
                    alignItems: "center",
                    textTransform: "capitalize",
                    width: "5px",
                    fontSize: "11px",
                    marginLeft: "6px",
                  }}
                  onClick={approvePerTeacherCredit}
                >
                  Approve
                </LoadingButton>
              )}
            </Box>
          </Grid> */}
          <FormControlLabel
            control={
              <Switch
                checked={props.checked}
                onChange={(e) => props.handleSelectCheckbox(e.target.checked)}
              />
            }
            label="Select All Checkboxes"
            labelPlacement="start"
            className="switch-label"
            sx={{ marginLeft: "0px" }}
          />
        </Grid>
      ) : (
        <Box
          sx={{
            // padding: "10px",
            borderRadius: "4px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {/* <Box sx={{ display: "flex", gap: "10px" }}>
            <Typography
              variant="subtitle1"
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "Karla, sans-serif",
              }}
            >
              ACV Licences :
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "Karla, sans-serif",
                fontWeight: 600,
              }}
            >
              1000
            </Typography>
          </Box> */}
          {/* <Box sx={{ display: "flex", gap: "10px" }}>
            <Typography
              variant="subtitle1"
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "Karla, sans-serif",
              }}
            >
              School Credits :
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "Karla, sans-serif",
                fontWeight: 600,
              }}
            >
              $300
            </Typography>
          </Box> */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: "10px",
              alignItems: "center",
            }}
          >
            <TextField
              id="search-bar"
              className="search-bar"
              variant="outlined"
              placeholder="Search..."
              size="small"
              value={props.searchTeacher}
              onChange={(e) => props.handleChange(e)}
            />
          </Box>
          <Box sx={{ display: "flex", gap: "10px" }}>
            <Typography
              variant="subtitle1"
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "Karla, sans-serif",
              }}
            >
              Available Credits :
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "Karla, sans-serif",
                fontWeight: 600,
              }}
            >
              {props?.creditInfo?.credit > -1 ? (
                props.creditInfo.credit
              ) : (
                <Skeleton width={30} variant="text" sx={{ fontSize: "1rem" }} />
              )}
            </Typography>
            {/* <Button
              sx={{
                color: "rgb(0, 0, 0)",
                border: "1px solid rgb(225, 223, 221)",
                fontFamily: "Karla, sans-serif",
                boxShadow: "rgba(0, 0, 0, 0.25) 0px 0.2rem 0.4rem -0.075rem",
                fontWeight: 600,
              }}
              onClick={increaseCredits}
            >
              $ Increase Credits
            </Button> */}
            <a
              href={`https://www.acv.app/credits`}
              target="_blank"
              style={{
                display: "flex",
                alignItems: "center",
                color: "rgb(0, 0, 0)",
                border: "1px solid rgb(225, 223, 221)",
                fontFamily: "Karla, sans-serif",
                boxShadow: "rgba(0, 0, 0, 0.25) 0px 0.2rem 0.4rem -0.075rem",
                fontWeight: 600,
                padding: "10px 20px",
                borderRadius: "5px",
                fontSize: "15px",
                textTransform: "uppercase",
              }}
            >
              $ Increase Credits
            </a>
          </Box>
          {/* <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <Typography
              variant="subtitle1"
              sx={{
                display: "flex",
                alignItems: "center",
                fontFamily: "Karla, sans-serif",
              }}
            >
              Credits per teacher
            </Typography>
            <TextField
              className="outlined-basic"
              label="Quota per teacher"
              variant="outlined"
              size="small"
              value={props.creditPerTeacher}
              onChange={setQuotaPerTeacher}
            />
            {props.creditPerTeacher && (
              <LoadingButton
                className="assigned"
                loadingPosition="start"
                variant="contained"
                style={{
                  backgroundColor: "rgb(98, 100, 167)",
                  height: "35px",
                  alignItems: "center",
                  textTransform: "capitalize",
                  width: "17%",
                  fontSize: "13px",
                }}
                onClick={approvePerTeacherCredit}
              >
                Approve
              </LoadingButton>
            )}
          </Box> */}
        </Box>
      )}
    </>
  );
}

export default CreditSection;
